import { useStyleSheet } from '../../hooks/useStyleSheet';
import { spin } from './Loading.helpers';
import { LOADING_SIZES_MAP } from './Loading.constants';
import { LoadingProps } from './Loading.types';

export const useStyles = ({
  color,
  fullscreen,
  size = 'lg',
}: Pick<LoadingProps, 'color' | 'fullscreen' | 'size'>) => {
  const styles = useStyleSheet(
    (theme) => {
      const loadingSizes = LOADING_SIZES_MAP[size];
      return {
        loadingInnerCircle: {
          zIndex: 1,
          width: loadingSizes.innerCircleWidth,
          height: loadingSizes.innerCircleHeight,
          border: `5px solid ${theme.palette.background.secondary}`,
          borderRadius: '50%',
          boxShadow: theme.boxShadows.secondary.main,
        },
        loadingOuterCircle: {
          position: 'relative',
          width: loadingSizes.outerCircleWidth,
          height: loadingSizes.outerCircleHeight,
          borderRadius: '50%',
          boxShadow: theme.boxShadows.secondary.inset,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        loadingAnimation: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: loadingSizes.animationWidth,
          height: loadingSizes.animationHeight,
          borderRadius: '50%',
          animation: `${spin} 2s linear infinite`,
          border: `4px solid ${theme.palette.background.secondary}`,
          borderTop: `4px solid ${color ?? theme.palette.primary.main}`,
        },
        progressBar: {
          width: fullscreen ? '100vw' : '100%',
          height: fullscreen ? '100vh' : '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.background.secondary,
          ...(fullscreen
            ? {
                position: 'fixed',
                borderRadius: '8px',
              }
            : {
                borderRadius: '9999px',
              }),
        },
      };
    },
    [color, fullscreen, size],
  );

  return styles;
};
